import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const DecodersEncodersApplications = () => (
  <DSDModuleSubtopic
    title="Decoders, Encoders and applications"
    videos={[
      "https://www.youtube.com/embed/NWiPVMDh7GE",
      "https://www.youtube.com/embed/a3wh7xV5PBU",
      "https://www.youtube.com/embed/3394TEnBAU0",
      "https://www.youtube.com/embed/kEj-m3YuGa4",
      "https://www.youtube.com/embed/smeUN1Bxj3M"
    ]}
    takeaways={[
      { text: "Practice mainly application based questions." },
      { text: "Practice problems from priority encoder." }
    ]}
    questions={[
      {
        text: "Implement the following multiple output Boolean Functions with suitable decoder and external gates F1(A,B,C) = ∑ m (0,4,7) + ∑dm (2,3) F2(A,B,C) = ∑ m (1,5,6) F3(A,B,C) = ∑ m (0,2,4,6) What is the advantage of the decoder"
      },
      {
        text: "The outputs of a combinational circuit is defined by the following three Boolean functions: F1(A,B,C) = ∑ (1,4,6) F2(A,B,C) = ∑ (3,5) F3(A,B,C) = ∑ (2,4,6,7) Implement the circuit using 3 x 8 decoder and NAND Gates only."
      },
      {
        text: "Design a combinational circuit with three inputs and output (a) and (b) only using 3: 8 Decoder constructed using 1:2 Decoder implemented using NOR logic in POS form. (a) The output is 1 when the binary value of the inputs is less than 3. The output is 0 otherwise. (b) The output is 1 when the binary value of the inputs is an even number. Write the mixed style Verilog code and test bench with line by line comments of the above design."
      },
      {
        text: "Write a behavioural level Verilog Code for 2:4 Decoder along with Test Bench"
      },
      {
        text: "Write the sum of minterms for the given circuit. Also write using K map, write SOP and POS Boolean expression for the circuit in canonical and standard form. Design the given circuit using 4X16 decoder constructed using 2x4 decoders (use only two input OR gates). Construct the internal circuit of 2x4 decoder using two input NAND logic.",
        image:"/dsd_10.png"
      },
      {
        text: "Identify the logic function implemented using the active low output decoder shown in the figure below. Write a code for the identified logic function using Dataflow Verilog HDL with minimal operators",
        image:"/dsd_11.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default DecodersEncodersApplications;
